import React from "react";

import * as images from "assets/images";

interface Props {
  children?: React.ReactNode;
  image?: string;
  title?: string | JSX.Element;
  "data-testid"?: string;
}

const ResultWrapper = ({ children, image, title, ...restProps }: Props) => {
  return (
    <div
      {...restProps}
      className="p-3 p-md-5 gap-3 gap-md-5 d-flex justify-content-center align-items-center flex-wrap"
    >
      {image && <img alt="Result" width="250em" src={image} />}
      <div className="text-center">
        {title && <h4>{title}</h4>}
        {children}
      </div>
    </div>
  );
};

const Empty = ({ image = images.empty, ...restProps }: Props) => (
  <ResultWrapper image={image} {...restProps} />
);

const Error = ({ image = images.warning, ...restProps }: Props) => (
  <ResultWrapper image={image} {...restProps} />
);

const NotFound = ({ image = images.warning, ...restProps }: Props) => (
  <ResultWrapper image={image} {...restProps} />
);

const Result = {
  Empty,
  Error,
  NotFound,
};

export default Result;
